import { authClient, defaultClient } from "@/shared/lib/axios";
import {
	type LoginRequest,
	type LoginResponse,
	LoginResponseSchema,
	type LogoutResponse,
	LogoutResponseSchema,
	type RefreshTokenRequest,
	type RefreshTokenResponse,
	RefreshTokenResponseSchema,
	type RegisterRequest,
	type RegisterResponse,
	RegisterResponseSchema,
	type ResendVerificationRequest,
	type ResendVerificationResponse,
	ResendVerificationResponseSchema,
	type VerifyEmailRequest,
	type VerifyEmailResponse,
	VerifyEmailResponseSchema,
} from "./auth.types";

const AUTH_ENDPOINT = "/auth";

export const authApi = {
	register: async (request: RegisterRequest): Promise<RegisterResponse> => {
		const { data } = await defaultClient.post(`${AUTH_ENDPOINT}/register`, request);
		return RegisterResponseSchema.parse(data);
	},

	login: async (request: LoginRequest): Promise<LoginResponse> => {
		const { data } = await defaultClient.post(`${AUTH_ENDPOINT}/login`, request);
		return LoginResponseSchema.parse(data);
	},

	refresh: async (request: RefreshTokenRequest): Promise<RefreshTokenResponse> => {
		const { data } = await defaultClient.post(`${AUTH_ENDPOINT}/refresh`, request);
		return RefreshTokenResponseSchema.parse(data);
	},

	verifyEmail: async (request: VerifyEmailRequest): Promise<VerifyEmailResponse> => {
		const { data } = await defaultClient.post(`${AUTH_ENDPOINT}/verify`, request);
		return VerifyEmailResponseSchema.parse(data);
	},

	resendVerification: async (
		request: ResendVerificationRequest,
	): Promise<ResendVerificationResponse> => {
		const { data } = await defaultClient.post(`${AUTH_ENDPOINT}/resend-verification`, request);
		return ResendVerificationResponseSchema.parse(data);
	},

	logout: async (): Promise<LogoutResponse> => {
		const { data } = await authClient.post(`${AUTH_ENDPOINT}/logout`);
		return LogoutResponseSchema.parse(data);
	},
};
